import { Injectable } from '@angular/core';
import { OrderPermission } from '../interface/common.interface';

@Injectable({
  providedIn: 'root',
})
export class AccessControlState {
  activeOrderId: string | null = null;
  permittedActions!: OrderPermission[];

  clear() {
    this.activeOrderId = null;
    this.permittedActions = undefined!;
  }
}
